import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Eye, ArrowRight, X } from 'lucide-react';
import { motion, AnimatePresence } from 'motion/react';

export const DemoBanner: React.FC = () => {
  const navigate = useNavigate();
  const [isDismissed, setIsDismissed] = React.useState(false);
  const isDemo = typeof sessionStorage !== 'undefined' && sessionStorage.getItem('is_demo_session') === 'true';

  if (!isDemo || isDismissed) return null;

  const handleSignUp = () => {
    // Clear demo state
    sessionStorage.removeItem('is_demo_session');
    localStorage.removeItem('mock_user_identity');
    localStorage.removeItem('active_org');
    navigate('/sign-up');
  };

  const handleExitDemo = () => {
    sessionStorage.removeItem('is_demo_session');
    localStorage.removeItem('mock_user_identity');
    localStorage.removeItem('active_org');
    window.location.href = '/';
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ y: -60, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        exit={{ y: -60, opacity: 0 }}
        className="bg-[#FFD600] border-b-4 border-black px-4 py-3 flex items-center justify-between gap-4 z-[60] relative"
      >
        <div className="flex items-center gap-3 flex-1 min-w-0">
          <div className="w-8 h-8 bg-black text-[#FFD600] flex items-center justify-center shrink-0">
            <Eye size={16} />
          </div>
          <p className="text-xs font-black uppercase tracking-[0.15em] text-black font-mono truncate">
            You're viewing a live demo — explore freely, nothing is saved
          </p>
        </div>
        <div className="flex items-center gap-3 shrink-0">
          <button
            onClick={handleSignUp}
            className="bg-black text-white px-5 py-2 text-[10px] font-black uppercase tracking-widest hover:bg-[#0044FF] transition-colors flex items-center gap-2"
          >
            Sign Up Free <ArrowRight size={12} />
          </button>
          <button
            onClick={handleExitDemo}
            className="bg-white text-black border-2 border-black px-4 py-2 text-[10px] font-black uppercase tracking-widest hover:bg-black hover:text-white transition-colors"
          >
            Exit Demo
          </button>
          <button
            onClick={() => setIsDismissed(true)}
            className="p-1 text-black/40 hover:text-black transition-colors"
          >
            <X size={16} />
          </button>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};
